import React from "react";
import HrAssessmentForm from "./HrAssessmentForm";

export default function AddHrAssessmentForm({ onSave, onCancel }) {
  function handleSave(data) {
    // 🔹 In future: call POST /assessments with data
    console.log("AddAssessmentForm save payload:", data);
    onSave?.(data);
  }

  return (
    <HrAssessmentForm
      initialData={null}
      mode="add"
      onSave={handleSave}
      onCancel={onCancel}
    />
  );
}